<template>
  <div class="page-column">
    <h2>单位名单</h2>
    <a-table :columns="columns" :data-source="data" :pagination="false" bordered>
      <template slot="name" slot-scope="text">
        <a>{{ text }}</a>
      </template>
      <template slot="title" slot-scope="currentPageData">
        搜索：<a-input-search placeholder="请输入编号或者学校名称搜索" style="width: 300px" @search="onSearch" />
        <a-pagination style="float: right;" v-if="data.length > 0" v-model="current" @change="pageData" :total="total" :pageSize="valData.pageSize" show-less-items />
      </template>
      <template slot="nickname" slot-scope="text, record">
        {{ text }}
        <a-popover title="全称修改" trigger="click">
            <template slot="content">
              全称：<a-input v-model="record.unitName" style="width:100px;"/>
              简称：<a-input v-model="record.abbreviation" style="width:100px;"/>
              <a-button type="primary" @click="updateUnitNameAll(record)">确定</a-button>
            </template>
            <a-button type="dashed" icon="edit" size="small"></a-button>
          </a-popover>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-switch :checked="record.enabled === 0" checked-children="启用" un-checked-children="禁用" @change="changeEnabled(record.id, $event)" default-checked />
        <a-button @click="$refs.userPwdModal.show(record.id)">修改密码</a-button>
      </template>
    </a-table>
    <UserPwdAgencyModal ref="userPwdModal" />
  </div>
</template>
<script>
import UserPwdAgencyModal from '@comm/components/center/modal/UserPwdAgencyModal'
export default {
  components: {
    UserPwdAgencyModal
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
              dataIndex: 'index',
              key: 'index',
              width: 100,                    
              fixed: 'left',
              customRender: (text,record,index) => `${(this.current*1-1)*this.valData.pageSize*1 + (index+1)}`, // 关键句
        },
        {
          title: '学校编号',
          dataIndex: 'account',
          scopedSlots: { customRender: 'account' },
        },
        {
          title: '学校名称',
          className: 'nickname',
          dataIndex: 'nickname',
          scopedSlots: { customRender: 'nickname' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: [],
      current: 1,
      valData: {
        pageNum: 1, 
        pageSize: 10,
        keyword: ''
      },
      total: 0
    }
  },
  mounted () {
    document.title = '道吧网 | 组委会 | 单位名单管理'
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.findAccountList(this.valData).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.total = res.total
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    pageData (page) {
      this.valData.pageNum = page
      this.findData()
    },
    onSearch (e) {
      console.log(e)
      this.valData.pageNum = 1
      this.valData.keyword = e
      this.findData()
    },
    changeEnabled (id, e) {
      this.$api.match.updateEnabled({id: id, enabled: e?0:1}).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.findData()
        } else {
          this.$message.error('失败')
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('失败')
      })
    },
    updateUnitNameAll (record) {
      if(record.agencyId === null){
        this.updateNickName(record)
      } else {
        this.$api.match.updateUnitNameAll(record).then(res => {
          if(res.status === 0){
            this.updateNickName(record)
            this.findData()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
            console.log(err)
        })
      }
      
    },
    updateNickName (record) {
      this.$api.match.updateNickname(record).then(res => {
        if(res.status === 0){
          this.$message.success('成功')
          this.findData()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
          console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 20px;
  .content {
    position: relative;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/organizing/Home.vue